import { createReduxAsyncThunk } from 'shared/utils';

import { stationsAPI } from 'entities/stations';

import { STATIONS_STATE } from '../../constants';

import {
  Station,
  StationsState
} from '../../types';

export const getSelectedStation = createReduxAsyncThunk<
  StationsState['selectedStation']['data'],
  Station['code']
>(
  `${STATIONS_STATE}/getSelectedStation`,
  async (stationCode, { signal, getState }) => {
    const { data } = await stationsAPI.getStation(stationCode, signal);
    // @ts-ignore
    const state = getState()[STATIONS_STATE] as StationsState;

    if (state.selectedStationOnMap?.code !== data.code) {
      return;
    }

    return data;
  }
);
